export default __webpack_public_path__ + "static/media/format_underlined.e800ae1b.svg";